import React, { Fragment, useState } from "react";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Button,
  CircularProgress,
  Backdrop,
  Divider,
  TextField,
} from "@material-ui/core";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import PreviewRoundedIcon from "@mui/icons-material/PreviewRounded";
import { useEffect } from "react";
import { useStylesApp } from "hooks/useStyles";
import { API_GET_ALL_TEMPLATE } from "widgets/Cafe/apis";
import { getRUCEmpresa } from "redux/actions/userActions";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Alert from "widgets/alert";
import { useSelector } from "react-redux";
import { clientBackendPDF, clientNotifier } from "configurations/axios";

const useStyles = makeStyles((theme) => ({
  IconButton: {
    marginTop: "1%",
    marginBottom: "1%",
    padding: "1px",
  },
  divInfoUser: {
    borderStyle: "solid",
    borderColor: palette.primary.main,
    borderWidth: "1px",
    borderRadius: "8px",
    marginTop: "1%",
  },
  divlabel: {
    marginTop: "1%",
  },
  buttonClose: {
    width: "75%",
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  backdrop: {
    zIndex: "3000",
    color: "#fff",
  },
}));
const ViewerVoucherBtn = ({ iDoc, txt, voucher }) => {
  const [open, setOpen] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [template, setTemplate] = useState([]);
  const [loadTemplate, setLoadTemplate] = useState(true);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const userToken = useSelector((state) => state.user.tk);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  //codigo del template para generar
  const [updateTemplate, setUpdateTemplate] = useState("");

  const handleClose = () => {
    setOpen(false);
    setTemplate([]);
    setSelectedTemplate({});
    setUpdateTemplate("");
  };

  const generateRide = async () => {
    setOpenLoader(true);
    return await clientBackendPDF
      .get(
        `/utilidades/generar/ride/${voucher.comprobanteElectronico.idComprobanteElectronico}?codigoPlantilla=${updateTemplate}`
      )
      .then((response) => {
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setOpenLoader(false);
        window.open(fileURL);
      })
      .catch((error) => {
        if (error.response) {
          setOpenLoader(false);
          console.error("error", error.response.data);
          setOpen(true);
        } else {
          console.error("error", error);
          setOpenLoader(false);
          setOpen(true);
        }
      });
  };

  function closeAlert() {
    setMsg({ show: false });
  }

  const handleClickOpen = () => {
    setOpen(true);
    setLoadTemplate(true);
    setMsg({ show: false, msg: null, type: null });
    setSelectedTemplate({});
    setUpdateTemplate("");
  };

  const getTemplates = async (token) => {
    setLoadTemplate(false);
    if (open) {
      await clientNotifier
        .get(API_GET_ALL_TEMPLATE + getRUCEmpresa(userToken) + "/" + iDoc)
        .then((result) => {
          if (result.status === 200) {
            let locations = result.data;
            for (let i = 0; i < locations.length; i++) {
              locations[i].label =
                locations[i].plantillaCafe.codigo +
                " / " +
                locations[i].plantillaCafe.nombre;
            }
            setTemplate(locations);
          }
        })
        .catch((exception) => {
          setTemplate([{ label: "Error al cargar los templates" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar los templates.",
          });
        });
    }
  };

  const renderTemplates = () => {
    if (template.length === 0 && userToken && loadTemplate) {
      getTemplates(userToken);
    }
    return (
      <>
        <Autocomplete
          value={selectedTemplate}
          onChange={(event, newValue) => {
            setSelectedTemplate(newValue);
          }}
          options={template}
          getOptionLabel={(option) => option.label}
          style={{ width: "95%" }}
          loading={template.length === 0}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Lista de templates"
              classes={{ root: classes.textFieldComboBox }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {template.length === 0 ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </>
    );
  };

  const handleGenerateTemplate = () => {
    if (selectedTemplate) {
      if (selectedTemplate.plantillaCafe)
        setUpdateTemplate(selectedTemplate.plantillaCafe.codigo);
    }
    generateRide();
  };

  useEffect(() => {
    if (selectedTemplate) {
      if (selectedTemplate.plantillaCafe)
        setUpdateTemplate(selectedTemplate.plantillaCafe.codigo);
    }
  }, [handleGenerateTemplate]);

  return (
    <Fragment>
      <IconButton
        color="primary"
        aria-label="upload picture"
        component="span"
        onClick={handleClickOpen}
        className={classes.IconButton}
      >
        <PreviewRoundedIcon></PreviewRoundedIcon>
      </IconButton>

      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">
          Seleccionar template
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12}>
              <label>
                Los campos marcados con ({" "}
                <font color={palette.error.main}> *</font> ) son obligatorios:
              </label>
            </Grid>
            {msgError.show ? (
              <Alert
                tipo={msgError.type}
                mensaje={msgError.msg}
                mesajeSubrayado={null}
                titulo={null}
                mostrar={msgError.show}
                cerrarAlerta={closeAlert}
              />
            ) : null}

            <Grid item md={1} xs={12} className={classes.divForm}>
              <label>Template:</label>
            </Grid>
            <Grid item md={5} xs={12} className={classes.divInput}>
              {renderTemplates()}
            </Grid>
            <Grid container spacing={3} justify="center">
              <Grid item md={12} xs={12}>
                <Divider></Divider>
              </Grid>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={handleGenerateTemplate}
                className={classesGlobal.marginButton}
              >
                {txt}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleClose}
                className={classesGlobal.marginButton}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Backdrop open={openLoader} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

export default ViewerVoucherBtn;
